import {
  CompanyContainer,
  CompanyContentContainer,
  CompanyTabsContent,
  CompanyTabsList,
} from "components/company/v3/CompanyContainers";
import useBrazilianRealEstateFundIssuer from "components/company/v3/context/hooks/useBrazilianRealEstateFundIssuer";
import { CompanyAboutTabEnum } from "components/company/v3/menu/enums";
import FiisAboutContent from "components/company/v3/realestatefunds/contents/about/FiisAboutContent";
import FiisCardsContent from "components/company/v3/realestatefunds/contents/about/FiisCardsContent";
import classNames from "components/ui/classNames";
import { Tabs } from "components/ui/Tabs";
import { HandCoinsIcon, InfoIcon } from "lucide-react";
import type { ReactNode } from "react";
import { useIntl } from "react-intl";

interface FiisAboutBoxProps {
  tickerSymbol: string;
  tab: CompanyAboutTabEnum;
  onChangeTab: (tab: CompanyAboutTabEnum) => void;
  children?: ReactNode;
}

export default function FiisAboutBox({ tickerSymbol, tab, onChangeTab, children }: FiisAboutBoxProps) {
  const intl = useIntl();
  const issuer = useBrazilianRealEstateFundIssuer();

  return (
    <CompanyContainer className="xl:h-full">
      <div className="flex w-full flex-col space-y-6">
        <CompanyContentContainer>
          <Tabs
            defaultValue={CompanyAboutTabEnum.ABOUT}
            value={tab}
            onValueChange={(value: string) => onChangeTab(value as CompanyAboutTabEnum)}
            className="w-full"
          >
            <CompanyTabsList
              activeTab={tab}
              tabs={[
                {
                  value: CompanyAboutTabEnum.ABOUT,
                  label: intl.formatMessage({
                    defaultMessage: "Sobre",
                    description: "Aba do menu superior da empresa",
                    id: "SqQ+WW",
                  }),
                  icon: <InfoIcon className="inline-flex" size={16} strokeWidth={2} />,
                },
                {
                  value: CompanyAboutTabEnum.COMPENSATION_POLICY,
                  label: intl.formatMessage({
                    defaultMessage: "Política de Remuneração",
                    description: "Aba do menu superior da empresa",
                    id: "0rcgmM",
                  }),
                  icon: <HandCoinsIcon className="inline-flex" size={16} strokeWidth={2} />,
                },
              ]}
            />

            <CompanyTabsContent value={CompanyAboutTabEnum.ABOUT}>
              <FiisAboutContent tickerSymbol={tickerSymbol} />
            </CompanyTabsContent>

            <CompanyTabsContent value={CompanyAboutTabEnum.COMPENSATION_POLICY}>
              <p
                className={classNames(
                  "text-sm leading-6 tracking-wide text-slate-600 dark:text-slate-400",
                  "sm:line-clamp-none sm:text-base sm:leading-7",
                )}
              >
                {issuer.administrator.compensationPolicy}
              </p>
            </CompanyTabsContent>
          </Tabs>
        </CompanyContentContainer>
        <FiisCardsContent />

        {children}
      </div>
    </CompanyContainer>
  );
}
